import { keywordActions } from "../../actionTypes";

const initialState = {
	keyword: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case keywordActions.DELETE_KEYWORD: {
			return { ...state, ...initialState };
		}

		case keywordActions.DELETE_KEYWORD_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				keyword: action.payload.data,
			};
		}

		case keywordActions.DELETE_KEYWORD_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
